export default {"src":"/_next/static/media/resort.dc06b11e.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};